import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react'
import { Form, Button } from 'react-bootstrap';
import { PostClaimMultipart } from '../network/ApiManager'
import { toServerFormat, enumToPresentableString } from '../utilities/StringUtils'
import { withRouter } from 'react-router';

class CreateClaim extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientType: 'Agent',
      requestType: 'Status Review Requested',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      brokerage: '',
    }
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    const { isAdmin } = this.props
    const { firstName, lastName, email, brokerage } = this.state

    if (isAdmin) {
      const formData = new FormData()
      formData.append("clientType", toServerFormat(this.state.clientType))
      formData.append("requestType", toServerFormat(this.state.requestType))
      formData.append("file", this.state.filepath)
      if (email && email.length > 0) formData.append("email", email)
      if (firstName && firstName.length > 0) formData.append("firstName", firstName)
      if (lastName && lastName.length > 0) formData.append("lastName", lastName)
      if (brokerage && brokerage.length > 0) formData.append("brokerage", brokerage)

      PostClaimMultipart(formData, (claim) => {
        this.props.history.push('/')
        alert('Claim created.')
      }, (error) => {
        alert(error)
      })
    }
    else {
      alert('Only admins can manually create claims.')
    }
  }

  handleChange(event) {
    const target = event.target
    let value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    if (name === 'file') {
      this.setState({ filepath: event.target.files[0], file: value })
    } else {
      this.setState({ [name]: value })
    }
  }

  render() {
    const { requestType, clientType, firstName, lastName, email, phone, brokerage, file } = this.state;
    const fileName = file ? file.split("\\").pop() : "Claim file"

    return (
      <Form style={{ padding: '20px' }}>
        <h2>Create Claim</h2>
        <Form.Group controlId="firstName">
          <Form.Label>First Name</Form.Label>
          <Form.Control type="input" name="firstName" value={firstName} onChange={this.handleChange} />
        </Form.Group>
        <Form.Group controlId="firstName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control type="input" name="lastName" value={lastName} onChange={this.handleChange} />
        </Form.Group>
        <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control type="input" name="email" value={email} onChange={this.handleChange} />
        </Form.Group>
        <Form.Group controlId="phone">
          <Form.Label>Phone</Form.Label>
          <Form.Control type="input" name="phone" value={phone} onChange={this.handleChange} />
        </Form.Group>
        <Form.Group controlId="brokerage">
          <Form.Label>Brokerage</Form.Label>
          <Form.Control type="input" name="brokerage" value={brokerage} onChange={this.handleChange} />
        </Form.Group>
        <div style={{ height: '8px' }} />
        <Form.Group controlId="type">
          <Form.Label>Type</Form.Label>
          <Form.Control as="select" name="requestType" value={enumToPresentableString(requestType)} onChange={this.handleChange}>
            <option>Status Review Requested</option>
            <option>New Build Agreement Review Requested</option>
          </Form.Control>
        </Form.Group>
        <div style={{ height: '8px' }} />
        <Form.Group controlId="clientType">
          <Form.Label>Client Type</Form.Label>
          <Form.Control as="select" name="clientType" value={enumToPresentableString(clientType)} onChange={this.handleChange}>
            <option>Agent</option>
            <option>Individual</option>
          </Form.Control>
        </Form.Group>
        <div style={{ height: '8px' }} />
        <Form.Group controlId="file">
          <Form.Label>Claim File</Form.Label>
          <Form.File
            id="file"
            label={fileName}
            name="file"
            custom
            onChange={this.handleChange}
          />
        </Form.Group>
        <div style={{ marginTop: '40px' }}>
          <Button style={{ marginLeft: '10px' }} variant="primary" onClick={() => { this.onSubmit() }}>
            Submit
          </Button>
        </div>
      </Form>
    );
  }
}

export default withRouter(CreateClaim);
